/**
 * This class handle the Term Filters
 * @author Yadian
 * Example
 *  {
        "type": "TERM",
        "field": "um.id.keyword",
        "value": "bb4cd88-c6b8-4a77-956a-0671189be008"
    }
 **/
import IFilter from "./IFilter";


export default class EmptyFilter extends IFilter {

    remove() {
        throw new Error('Not implemented yet!');
    }

    /**
     * @return {IFilter}
     * */
    clone() {
        return new EmptyFilter();
    }

    /**
     * @return {any}
     * */
    toQuery() {
        return;
    }

    /**
     * Converts options to a MongoDB query object.
     *
     * @param {{flat: boolean}| undefined} An optional object containing options for the query.
     * @return {Object} - The MongoDB query object.
     */
    toMongoQuery() {
        return;
    }

    get isEmpty() {
        return true;
    }

    /**
     * @param filter {any}
     * @return {IFilter}
     * */
    removeFilterRecursive(filter) {
        return;
    }

    /**
     * @param filter {any}
     * @return {IFilter}
     * */
    removeFilter(filter) {
        return;
    }
}


// module.exports = EmptyFilter;
